export default __webpack_public_path__ + "static/media/cert-student-hkgcsmeaa.0064ab19.jpg";